import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { assign } from 'lodash';

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export default function withCondition(WrappedComponent) {
  class WithConditionComponent extends Component {
    render() {
      let rest = assign({}, this.props);
      delete rest['isAvailable'];
      return this.props.isAvailable ? <WrappedComponent {...rest} /> : null;
    }
  }

  WithConditionComponent.propTypes = {
    isAvailable: PropTypes.bool
  };

  WithConditionComponent.displayName = `WithConditionComponent(${getDisplayName(
    WrappedComponent
  )})`;

  return WithConditionComponent;
}



// WEBPACK FOOTER //
// ./src/javascripts/hocs/withCondition.js